import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {Link, useLocation} from "react-router-dom";
import {connect} from "react-redux";
import {Button, Collapse, List, ListItem, ListItemIcon,} from "@material-ui/core";
import {siteNav} from "../../../app-bar/SiteNavigation";

const useStyles = makeStyles(theme => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
  icon: {
    minWidth: 20,
  },
}));

const MobileMenu = props => {
  const classes = useStyles();
  const location = useLocation();
  const [isExploreOpen, setExploreOpen] = React.useState(false);
  const [isProfileOpen, setProfileOpen] = React.useState(false);
  const [isAvatarOpen, setAvatarOpen] = React.useState(false);
  const [isSocialOpen, setSocialOpen] = React.useState(false);
  const [isAdminOpen, setAdminOpen] = React.useState(false);
  const [isSpacecastOpen, setSpacecastOpen] = React.useState(false);
  const isMindfileMember = (props.isCurrentMindfileOwner || (props.mindfile.contributors || []).some(contributor => contributor.id === props.user.uid));

  const openState = {
    explore: [isExploreOpen, setExploreOpen],
    profile: [isProfileOpen, setProfileOpen],
    avatar: [isAvatarOpen, setAvatarOpen],
    social: [isSocialOpen, setSocialOpen],
    admin: [isAdminOpen, setAdminOpen],
    spacecast: [isSpacecastOpen, setSpacecastOpen],
  };

  useEffect(() => {
    for(let key in openState) {
      if (location.pathname.startsWith(`/${key}`)){
        openState[key][1](true);
      }
    }
  }, [location, openState]);


  const isOpen = (item) => {
    switch (item.key) {
      case "explore":
        return isExploreOpen;
      case "profile":
        return isProfileOpen;
      case "avatar":
        return isAvatarOpen;
      case "social":
        return isSocialOpen;
      case "admin":
        return isAdminOpen;
      case "spacecast":
        return isSpacecastOpen;
      default:
        return false;
    }
  }

  function handleClick(item) {
    let clickHandler;
    switch (item) {
      case "explore":
        clickHandler = () => {
          setExploreOpen(!isExploreOpen);
        };
        break;
      case "profile":
        clickHandler = () => {
          setProfileOpen(!isProfileOpen);
        };
        break;
      case "avatar":
        clickHandler = () => {
          setAvatarOpen(!isAvatarOpen);
        };
        break;
      case "social":
        clickHandler = () => {
          setSocialOpen(!isSocialOpen);
        };
        break;
      case "admin":
        clickHandler = () => {
          setAdminOpen(!isAdminOpen);
        };
        break;
      case "spacecast":
        clickHandler = () => {
          setSpacecastOpen(!isSpacecastOpen);
        };
        break;
      case "contact":
        clickHandler = () => {
          props.openContactDialog();
          props.closeDrawer();
        }
        break;
      // Help dialog auto opens for #help_load anchor, nothing to do here
      // case "help":
      //   clickHandler = () => {
      //     props.openHelpDialog();
      //     props.closeDrawer();
      //   }
      //   break;
      case "close-drawer":
      default:
        clickHandler = () => {
          props.closeDrawer();
          setExploreOpen(false);
          setProfileOpen(false);
          setAvatarOpen(false);
          setSocialOpen(false);
          setAdminOpen(false);
          setSpacecastOpen(false);
        };
        break;
      // default:
      //   clickHandler = () => {};
      //   break;
    }
    return clickHandler;
  }

  const renderChild = (item) => {
    if((item.enabled === "owner" || item.enabled === "manage") && !props.isCurrentMindfileOwner){
      return null;
    }else if((item.enabled === "member" || item.enabled === "edit") && !isMindfileMember){
      return null;
    }else if(item.enabled === "admin" && !props.user.is_admin){
      return null;
    }else if(item.enabled === "avatar" && new Date(props.mindfile.created_at) > new Date("2023-11-15")) {
      return null;
    }
    return <ListItem
        key={item.label}
        className={classes.nested}
        onClick={handleClick("close-drawer")}
        component={Link}
        to={item.path}
      >
        <ListItemIcon
          className={classes.icon}
          children={item.icon}
        />
        <Button>{item.label}</Button>
      </ListItem>;
  };

  const renderParent = (item) => {
    if((item.enabled === "owner" || item.enabled === "manage") && !props.isCurrentMindfileOwner){
      return null;
    }else if((item.enabled === "member" || item.enabled === "edit") && !isMindfileMember){
      return null;
    }else if(item.enabled === "admin" && !props.user.is_admin){
      return null;
    }else if(item.enabled === "avatar" && new Date(props.mindfile.created_at) > new Date("2023-11-15")) {
      return null;
    }
    const button = <ListItem key={item.key} {...item.itemProps} onClick={handleClick(item.key)}>
        <ListItemIcon className={classes.icon} children={item.icon} />
        <Button>{item.label}</Button>
      </ListItem>;

    return !item.children ? button : [button,
        <Collapse key={`${item.key}_sub`} in={isOpen(item)} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children.map(renderChild)}
          </List>
        </Collapse>];
  };

  return (
    <List component="nav">
      {siteNav.map(renderParent)}
    </List>
  );
};

const mapStateToProps = state => ({
  user: state.auth,
  isCurrentMindfileOwner: state.isCurrentMindfileOwner,
  mindfile: state.mindfile,
});

export default connect(mapStateToProps)(MobileMenu);
